<template>
  <div class="widget-field-error">{{ text }}</div>
</template>

<script lang="ts">
import { defineComponent } from '@/composition/vue/compositionApi'

export default defineComponent({
  props: {
    text: {
      type: String,
    },
  },
})
</script>

<style lang="scss" scoped>
@import '@/styles/custom-variables';

.widget-field-error {
  // Important to override more specific styles in quasar-field.scss
  font-size: $sm-font !important;
  font-weight: $regular-font !important;
  line-height: 14px !important;
  color: $error !important;
}
</style>
